import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'assessment-result-details-shared',
  templateUrl: 'assessment-result-details-shared.component.html'
})
export class AssessmentResultDetailsSharedComponent implements OnInit {
  initialized = false;


  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }

}
